export default "__VITE_ASSET__BUBi$LVQ__"